/*
    Javascript port of the encoding service from et-common
 */
define('shared/util/security/Encoding',['shared/lib/RSVP'], function(RSVP){

    function createCharArray(size) {
        var ret = [];
        
        for (var i = 0; i < size; i++) {
            ret[i] = 0;    
        }
        
        return ret;
    }

    function createDecodeDictionary(input) {
        var inputLength = input.length;
        var output = createCharArray(256);
        
        for( var i = 0; i < inputLength; i++) {
            output[input[i]] = i;
        }
        
        return output;
    }

    function Ctor() {

        this._encodeDictionary6;
        this._decodeDictionary6;
        
        var encodedictionary = createCharArray(64);
        
        var iter = 0;
        var i;
        
        for(i = 65; i <= 90; i++){
            encodedictionary[iter] = i;
            iter++;
        }
        
        for(i = 97; i <= 122; i++){
            encodedictionary[iter] = i;
            iter++;
        }
        
        for(i = 48; i <= 57; i++){
            encodedictionary[iter] = i;
            iter++;
        }
        
        encodedictionary[iter] = '+'.charCodeAt(0);
        iter++;
        encodedictionary[iter] = '-'.charCodeAt(0);
        
        this._encodeDictionary6 = encodedictionary;
        this._decodeDictionary6 = createDecodeDictionary(encodedictionary);
    }
    
    function convertStringToCharArray(input) {
        var ret = [];
      
        for( var i = 0; i < input.length; i++ ) {
            ret.push( input.charCodeAt(i) );
        }
        
        return ret;
    }
    
    function convertCharArrayToString(chars) {
        var ret = '';
        
        for( var i = 0; i < chars.length; i++ ) {
            ret+= String.fromCharCode(chars[i]);
        }
        
        return ret;
    }
    
    function convertNumberToChar(num) {
        return num & 65535;
    }
    
    function recode(input, dictionary) {
        var inputLength = input.length - 1;
        var output = createCharArray(inputLength + 1);
        
        for ( var i = 0; i <= inputLength; i++ ) {
            output[i] = dictionary[input[i]];
        }
        
        return output;
    }
    
    function convertBitBase(input, inBits, outBits, pad){
        var outMask = 0;
        var inputLength;
        var outputLength;
        var cog = 0;
        var data = 0;
        var iIterator = 0;
        var oIterator = 0;
        var output;
        
        for(var i = 0; i < outBits; i++) {
            outMask = outMask << 1 | 1;
        }
        
        inputLength = input.length;
        outputLength = Math[ pad ? 'ceil' : 'floor' ]( inputLength * inBits * 1.0 / outBits );
        
        output = createCharArray(outputLength + 1);
        
        while ( oIterator < outputLength ) {
            
            while ( cog < outBits ) {
                data = data << inBits;
                
                if ( iIterator < inputLength ) {
                    data = data | input[iIterator];
                    iIterator++;
                }
                
                cog = cog + inBits;
            }
            
            while( cog >= outBits && oIterator < outputLength ) {
                output[oIterator] = convertNumberToChar(data >> (cog - outBits) & outMask );
                oIterator++;
                cog = cog - outBits;
            }
        }
        
        return output;
    }
    
    var p = Ctor.prototype;
    
    p.encode = function(input){
        var inBits = 16;
        var outBits = 6;
        var pad = true;
        
        var inchars = convertStringToCharArray(input);
        var convertedchars = convertBitBase(inchars, inBits, outBits, pad);
        var recodedchars = recode(convertedchars, this._encodeDictionary6);
        
        return RSVP.resolve(convertCharArrayToString(recodedchars));
    };
    
    p.decode = function(input){
        var inBits = 6;
        var outBits = 16;
        var pad = false;
        
        var inchars = convertStringToCharArray(input);
        var decodedchars = recode(inchars, this._decodeDictionary6);
        var convertedchars = convertBitBase(decodedchars, inBits, outBits, pad);
        
        convertedchars.pop();
        
        return RSVP.resolve(convertCharArrayToString(convertedchars));
    };

    // create instance
    Ctor.instance = new Ctor();
    
    return Ctor;
});
